import { Component, OnInit } from '@angular/core';
import * as  moment from 'moment';
import { EmployeeServiceService } from 'src/providers/employee-service/employee-service.service';
import { MatTableModule } from '@angular/material/table';
import { DaytranService } from 'src/providers/daytran-ervice/daytran.service';
import { Daytran } from 'src/core/daytran.model';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TimeLogsComponent } from './time-logs/time-logs.component';
import { AuthorizationComponent } from './authorization/authorization.component';
import { VoidTimelogComponent } from './void-timelog/void-timelog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { WebcamImage, WebcamComponent } from 'ngx-webcam';
import { SnapShotComponent } from './snap-shot/snap-shot.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'Webclock';
  id = '';
  currentTime = moment().format('LTS');
  today = moment().format('MMMM DD, YYYY');
  employees: Array<any>;
  timeins;
  hide_voidreq;
  show_xptclockentries;

  constructor(
    private employeeService: EmployeeServiceService,
    private daytranService: DaytranService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) {
    this.startTimer();
    this.initialize();
  }

  openTimeLogs() {
    const modalRef = this.modalService.open(AuthorizationComponent, { size: 'sm' });
    modalRef.componentInstance.auth_module = 'TimeLogs';
  }

  openExportTimeLogs() {
    const modalRef = this.modalService.open(AuthorizationComponent, { size: 'sm' });
    modalRef.componentInstance.auth_module = 'ExportClockEntires';
  }

  openVoidRequest() {
    const modalRef = this.modalService.open(VoidTimelogComponent, { size: 'xl' });
  }

  async startTimer(): Promise<void> {
    setInterval(() => {
      this.currentTime = moment().format('LTS');
      this.today = moment().format('MMMM DD, YYYY');
    }, 1000);
  }

  async initialize(): Promise<void> {
    this.timeins = await this.daytranService.getDaytran().then(next => next.daytran);
    const syspar = await this.daytranService.photoEnabled();
    this.hide_voidreq = syspar.hide_voidreq;
    this.show_xptclockentries = syspar.show_xptclockentries;
  }

  clear(): void {
    this.id = '';
  }

  input(code): void {
    this.id = this.id === '' ? code : this.id.concat(code);
  }

  del(): void {
    this.id = this.id.slice(0, -1);
  }

  async submit(type: string): Promise<void> {
    const modalRef = this.modalService.open(ConfirmDialogComponent, { size: 'sm' });
    modalRef.componentInstance.empno = this.id;
    modalRef.componentInstance.type = type;
    modalRef.result.then(next => this.initialize());
    this.id = '';
  }
}


